import type { ChatUi } from '@voll-intelligence/genui-contract';
import type { GenUiDispatch } from '../../shared/ui/action.js';
import { useGenUiI18n } from '../../shared/ui/i18n.js';
import type { GenUiEntry } from '../../shared/ui/registry.js';
import { FlightSearchConfirmationCard } from './ui/flight_search_confirmation.js';

export { FlightSearchConfirmationCard } from './ui/flight_search_confirmation.js';

type FlightSearchConfirmationUi = Extract<ChatUi, { kind: 'flight_search_confirmation' }>;

/**
 * O botão "Buscar voos" dispara a busca via quick-reply (= o cliente
 * confirmando); omitido quando o card está read-only (histórico/resolvido).
 *
 * **Componente e não um lambda no `render` (#2327, mesmo padrão de
 * `bus/bus_offers/index.tsx`).** O eco precisa do locale da sessão, e `render`
 * é uma função de catálogo onde hook não roda.
 */
function FlightSearchConfirmationEntry({
  ui,
  note,
  readOnly,
  dispatch,
}: Readonly<{
  ui: FlightSearchConfirmationUi;
  note?: string;
  readOnly?: boolean;
  dispatch: GenUiDispatch;
}>) {
  const { t } = useGenUiI18n();
  return (
    <FlightSearchConfirmationCard
      search={ui.search}
      note={note}
      onSearch={
        readOnly
          ? undefined
          : () => {
              dispatch({ type: 'reply', text: t('flightSearchConfirmation.replySearch') });
            }
      }
    />
  );
}

/** Entrada de catálogo do `flight_search_confirmation` (slot chat). */
export const flightSearchConfirmationEntry: GenUiEntry<FlightSearchConfirmationUi> = {
  kind: 'flight_search_confirmation',
  slot: 'chat',
  policy: { productOf: () => 'flight' },
  render: ({ ui, note, readOnly, dispatch }) => (
    <FlightSearchConfirmationEntry
      ui={ui}
      {...(note ? { note } : {})}
      {...(readOnly ? { readOnly } : {})}
      dispatch={dispatch}
    />
  ),
};
